<template lang="pug">
router-view
</template>
              <script>
export default {
  name: "emptyRouterComponent",
};
</script>
              <style lang="scss" scoped>
</style>